<template lang="pug">
  div(:class="$style.page")
    div(:class="$style.modal")
      h1(:class="$style.title") Create a New Course

      // Course Details Step
      el-form(:model="formData" :rules="rules" ref="courseForm")
        el-form-item(label="Course Code" prop="code")
          el-input(v-model="formData.code")
        el-form-item(label="Course Title" prop="title")
          el-input(
            type="textarea"
            v-model="formData.title"
            :maxlength="200"
            show-word-limit
            rows="2"
          )
        el-form-item(label="Course Description" prop="descscription")
          el-input(
            type="textarea"
            v-model="formData.descscription"
            :maxlength="1000"
            show-word-limit
            rows="4"
          )

      
      // Navigation Buttons
      div(:class="$style.buttons")
        el-button(
          @click="goHome"
          :loading="loading"
        ) Cancel
        el-button(
          type="primary"
          @click="submitForm"
          :loading="loading"
        ) Submit
</template>

<script>
  import masterApiCall from '@/masteradmin/utils/api'

  export default {
    data() {
      return {
        currentStep: 0,
        steps: [
          { title: 'Account' },
          { title: 'Course Details' },
          { title: 'Complete!' },
        ],
        formData: {
          code: '',
          title: '',
          descscription: '',
        },
        rules: {
          title: [{ required: true, message: 'Please enter course title', trigger: 'blur' }],
          code: [{ required: true, message: 'Please enter course code', trigger: 'blur' }],
          descscription: [{ required: false, trigger: 'blur' }],
        },

        loading: false,
      }
    },

    methods: {
      goHome() {
        this.$router.push('/')
      },

      async submitForm() {
        this.loading = true
        masterApiCall('post', '/masteradmin/new-course', this.formData)
          .then(() => {
            this.$notify.success({
              title: 'Course Creation Success',
              message: 'Your course was successfully created.',
              position: 'bottom-right',
            })
            this.goHome()
          })
          .catch((error) => {
            const errorMessage = error.response && error.response.data && error.response.data.error
              ? error.response.data.error
              : 'Course creation was unsuccessful.'
            this.$notify.error({
              title: 'Course Creation Error',
              message: errorMessage,
              position: 'bottom-right',
              duration: 10000,
            })
          })
          .finally(() => {
            this.loading = false
          })
      },
    },
  }
</script>


<style module>
  .page {
    width: 100%;
    height: 100%;
  }

  .modal {
    max-width: 800px;
    margin: 5% auto;
    padding: 64px 64px 24px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  }

  .logo {
    width: 35%;
    display: block;
    margin: 0 auto;
    margin-bottom: 12px;
  }

  .title {
    color: var(--hvu-blue);
    text-align: center;
     margin-bottom: 24px;
  }

  .buttons {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }

  .thankYou {
    text-align: center;
    padding: 40px 0;
  }

  .thankYou p {
    padding: 32px 64px;
    text-align: justify;
    line-height: 1.5em;
  }

  .steps {
    margin-bottom: 32px;
  }

  /* Target Element UI classes to override default styles */
  :global(.el-step__title) {
    font-size: 16px;
    color: #909399 !important;
    position: absolute !important;
    width: max-content !important;
    transform: translateX(-30%) !important;
  }

  :global(.el-step__main) {
    min-height: 48px;
    display: flex;
    justify-content: flex-start;
    width: 100%;
  }

  :global(.el-steps) {
    max-width: 80%;
    margin: 0 auto;
  }

  :global(.el-step__title.is-success) {
    color: var(--hvu-blue) !important;
  }

  :global(.el-step__title.is-process) {
    color: var(--hvu-blue) !important;
    font-weight: 600;
  }

  :global(.el-step__head.is-success) {
    color: var(--hvu-blue) !important;
    border-color: var(--hvu-blue) !important;
  }

  :global(.el-step__head.is-process) {
    color: var(--hvu-blue) !important;
    border-color: var(--hvu-blue) !important;
  }

  :global(.el-step__line) {
    background-color: #DCDFE6;
  }

  :global(.el-step.is-success .el-step__line) {
    background-color: var(--hvu-blue);
  }

  :global(.el-step__head.is-success .el-step__icon.is-text) {
    background-color: var(--hvu-blue) !important;
  }

  :global(.el-step__head.is-success .el-step__icon-inner) {
    color: #ffffff !important;
  }

  :global(.el-form-item) {
    margin-bottom: 24px !important;  /* Reduce default spacing between form items */
  }

  :global(.el-form-item__label) {
    padding-bottom: 4px !important;  /* Reduce space between label and input */
    line-height: 1.2 !important;     /* Tighter line height for labels */
  }

  :global(.el-input) {
    line-height: 1 !important;       /* Tighter line height for inputs */
  }

  :global(.el-form) {
    margin-top: 8px;                 /* Add a bit of space after the stepper */
  }

</style>




// WEBPACK FOOTER //
// client/masteradmin/pages/CreateCourse/CreateCourse.vue